import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../core/pipes/t.pipe';

export type PageSkeletonVariant = 'home' | 'product' | 'catalog' | 'cards' | 'cms';

@Component({
  selector: 'app-page-skeleton',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './page-skeleton.component.html',
  styleUrls: ['./page-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageSkeletonComponent {
  @Input() variant: PageSkeletonVariant = 'cards';
  @Input() cards = 10;

  readonly categorySlots = Array.from({ length: 10 }, (_, i) => i);
  readonly productSlots = Array.from({ length: 5 }, (_, i) => i);

  get cardSlots(): number[] {
    return Array.from({ length: Math.max(4, this.cards) }, (_, i) => i);
  }
}
